import React from 'react';

import './ButtonInfo.scss';

const ButtonInfo = props => (
  <button type="button" onClick={props.onClick} className="button button--info">i</button>
);

export default ButtonInfo;
